export default __webpack_public_path__ + "static/media/ProductPageImage10.789f798d.jpg";